import { render, staticRenderFns } from "./exceptionSet.vue?vue&type=template&id=5989f689&scoped=true&"
import script from "./exceptionSet.vue?vue&type=script&lang=js&"
export * from "./exceptionSet.vue?vue&type=script&lang=js&"
import style0 from "./exceptionSet.vue?vue&type=style&index=0&id=5989f689&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5989f689",
  null
  
)

export default component.exports